module.exports = __webpack_public_path__ + "media/images/error/internal-server-a586f828123dfd1ee9073f262ec83d3a.svg";